<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-user-check"></i></div>
      <div>
        Validation des inscriptions
        <div class="page-title-subheading">Inscriptions en attente de validation par classe</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>
    <div class="row">
        <div class="col-lg-12">
            
            <div class="card">

                <div class="container py-3 d-flex justify-content-around ">
                    <div class="form-group">
                        <label for=""><strong>Classe:</strong> </label>
                        <select (change)="loadStudents($event)" name="" id="">
                            <option selected disabled></option>
                            <option *ngFor="let c of classrooms" [value]="c.id">{{c.name}}</option>
                        </select>
                    </div>
                 
                </div>
                <div class="card-body">
                    <div class="d-flex flex-column flex-md-row justify-content-between mb-5 " *ngIf="buttonsPermission">
                      
                           
                                <button *ngIf="selected_data && buttonsPermission.show" (click)="show()" type="button" class="btn btn-outline-primary btn-sm btn-label waves-effect waves-light me-3 mb-1">
                                    <span>Consulter</span></button>
                                    <button *ngIf="is_active==null || !is_active" (click)="setStatus(1)" type="button" class="btn btn-outline-success btn-sm btn-label waves-effect waves-light me-3 mb-1">
                                        Valider la classe de l'apprenant</button>
                                     <button  *ngIf="is_active==null || is_active" (click)="setStatus(0)" type="button" class="btn btn-outline-danger btn-sm btn-label waves-effect waves-light me-3 mb-1">
                                Suspendre la validation</button>
                    
                        <div class="form-group ms-auto">
                            <label for="search_text" class="form-label mb-0"><strong>Rechercher</strong></label>
                            <input id="search_text" type="text" name="search_text" class="form-control form-control-sm"
                                   placeholder="Rechercher..." [(ngModel)]="search_text">
                        </div>
                    </div>
    
                            <p>{{data!.length}} élément(s)</p>
                            <div class="table-responsive">
                            <table class="table" >
                                <thead class="">
                                    <tr>
                                        <th style="width: 10px;">#</th>
                                        <th>Libellé</th>
                                        <th>Statut</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr (click)="checked(d)" [class.table-active]="selected_data?.id === d.id" style="cursor: pointer;" *ngFor="let d of data | sampleSearch:search_text:'inscription_validations' | paginate: {
                                    itemsPerPage: pg.pageSize,
                                    currentPage: pg.p,
                                    totalItems: pg.total } ">
                                        <td>
                                            <div class="form-check mb-2">
                                                <input (click)="checked(d)" class="form-check-input" type="radio" [checked]="selected_data?.id === d.id" name="flexRadioDefault">
                                            
                                            </div>
                                        </td>
                                        <td>{{d.student?.lastname}} {{d.student?.firstname}}</td>
                                        <td>
                                            <span *ngIf="d.is_active" class="badge bg-success">Validé</span>
                                            <span *ngIf="d.is_active==0" class="badge bg-danger">Rejeté</span>
                                            <span *ngIf="d.is_active==null" class="badge bg-warning">En attente de validation</span>
    
                                        </td>
                                    </tr>
                                
                                </tbody>
                            </table>
                            </div>
                            <pagination-controls 
                          [maxSize]="9"
                          [directionLinks]="true"
                          [autoHide]="true"
                          [responsive]="true"
                          [previousLabel]="'Previous'"
                          [nextLabel]="'Next'"
                          [screenReaderPaginationLabel]="'Pagination'"
                          [screenReaderPageLabel]="'page'"
                          [screenReaderCurrentLabel]="'You\'re on page'">
                         </pagination-controls>
    
                </div><!-- end card -->
            </div>
            <!-- end col -->
        </div>
        <!-- end col -->
    </div>
    